import { useMutation } from "react-query";
import { playlistBusinessTypesApi } from "frontend/src/api/playlist-business-types";
import { queryClient } from "frontend/src/domain/query-client";
import { notify } from "frontend/src/features/notifications";
import { playlistBusinessTypesCacheKey } from "./shared";
export var useCreatePlaylistBusinessType = function () {
    return useMutation(playlistBusinessTypesApi.create, {
        onSuccess: function () { return queryClient.refetchQueries(playlistBusinessTypesCacheKey); },
    });
};
export var useChangePlaylistBusinessTypePublishStatus = function () {
    return useMutation(playlistBusinessTypesApi.changePublishStatus, {
        onError: function (_, _a) {
            var publish = _a.publish;
            notify({
                variant: "error",
                message: publish
                    ? "При публикации категории произошла ошибка"
                    : "При снятии категории с публикации произошла ошибка",
            });
        },
        onSuccess: function (_, _a) {
            var publish = _a.publish;
            notify({
                variant: "success",
                message: publish
                    ? "Категория опубликовна"
                    : "Категория снята с публикации",
            });
            return queryClient.refetchQueries(playlistBusinessTypesCacheKey);
        },
    });
};
